<template>
	<div>
		<div class="modal fade" id="CatModal" data-backdrop="static">
			<div class="modal-dialog" role="document">
				<div class="modal-content">
					<div class="modal-header">
						<button
							type="button"
							class="close"
							data-dismiss="modal"
							aria-label="Close"
						>
							<span aria-hidden="true">&times;</span>
						</button>
						<h4 class="modal-title" id="myModalLabel">Categoria</h4>
					</div>
					<div class="modal-body">
						<div class="col-sm-3">
							<span>Código</span>
							<input
								type="text"
								v-model="data.cod"
								disabled
								class="form-control"
							/>
						</div>

						<div class="col-sm-6">
							<span>Categorias</span>
							<input
								type="text"
								v-model="data.titulo"
								class="form-control"
							/>
						</div>

						<div class="col-sm-3">
							<span>Redução</span>
							<div class="input-group">
								<input
									type="number"
									v-model="data.reducao"
									class="form-control"
								/>
								<span class="input-group-addon">%</span>
							</div>
						</div>

						<div class="clearfix"></div>
						<br />
						<!-- <pre>{{data}}</pre> -->
					</div>
					<div class="modal-footer">
						<button
							type="button"
							class="btn btn-default"
							data-dismiss="modal"
						>
							<i class="fa fa-close"></i> Cancelar
						</button>
						<aBtn
							action="private-save-categories"
							@click="save"
							text="Salvar"
							icon="save"
							type="primary"
						/>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import clone from 'js/clone';
	import aBox from 'box';
	import aBtn from 'btn';
	import WBS from 'js/http';
	import toastr from 'toastr';
	let reset = { cod: '', titulo: '', reducao: 0, uid: '' };

	export default {
		name: 'ChModalCategorias',
		components: { aBox, aBtn },
		data() {
			return {
				data: clone(reset),
			};
		},
		methods: {
			open(data = null) {
				if (data != null) this.data = clone(data);
				else this.data = clone(reset);
				$('#CatModal').modal('show');
			},
			save() {
				WBS.send('private-save-categories', this.data, (resp) => {
					if (resp.status == 'success') {
						toastr.success('Registro alterado com sucesso!');
						this.$emit('update');
						$('#CatModal').modal('hide');
					} else {
						toastr.error(resp.msgs[0]);
						console.log(resp);
					}
				});
			},
		},
	};
</script>



// WEBPACK FOOTER //
// src/components/cadastros/categorias/modal.vue